import type { ErrorEvent } from "@sentry/nextjs";

/** Кадры нашего бандла: чанки Next.js на любом хосте, включая tauri://localhost. */
const OWN_CODE = /\/_next\/|_next\/static/;

/**
 * Событие целиком пришло из чужого кода — расширения браузера, юзерскрипта,
 * инжекта в страницу.
 *
 * Маска обфусцированных идентификаторов (`_0x…`) такое не ловит: у части
 * инжектов имена обычные. Живой пример — GlitchTip FRONTEND-27, 598 событий
 * `Cannot read properties of undefined (reading 'M_ID')` из
 * `app:///executors/200.js` в `XMLHttpRequest.onreadystatechange`: расширение
 * оборачивает XHR страницы и падает на КАЖДОМ ответе.
 *
 * Судим по происхождению кадров, а не по тексту ошибки. Событие без кадров с
 * файлом пропускаем: так выглядят наши собственные брошенные `Error`, и
 * отсекать их нельзя.
 */
export function isForeignStack(event: ErrorEvent): boolean {
  const framesWithFile = (event.exception?.values ?? [])
    .flatMap((value) => value.stacktrace?.frames ?? [])
    .filter((frame) => !!frame.filename);

  if (framesWithFile.length === 0) return false;

  return !framesWithFile.some((frame) => OWN_CODE.test(frame.filename ?? ""));
}
